import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef, OnInit } from '@angular/core';
import { QueryService } from '../comun/services/query.service';

export interface BannerHomeAcceso {
  titulo: string;
  subtitulo: string;
  icono: string;
  url: string;
  ariaLabel: string;
}

@Component({
  selector: 'app-banner-home',
  templateUrl: './banner-home.component.html',
  styleUrls: ['./banner-home.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BannerHomeComponent implements OnInit {
  /** Ruta absoluta o relativa a la fotografía situada en WordPress /img. */
  @Input() imagenUrl = '/img/banner-home-iguau.jpg';
  /** Se obtiene directamente de la API misdatos. */
  misdatos: any = null;
  @Input() baseUrl = '/';

  @Input() titulo1 = 'Familias';
  @Input() titulo2 = 'con huellas';
  @Input() descripcion = 'La red social donde las mascotas conectan personas, comparten experiencias y viven grandes aventuras juntas.';
  @Input() accesos: BannerHomeAcceso[] = [
    { titulo: 'Crea el perfil', subtitulo: 'de tu mascota', icono: 'fa-paw', url: '/register', ariaLabel: 'Crear el perfil de tu mascota' },
    { titulo: 'Haz nuevos', subtitulo: 'amigos', icono: 'fa-user-group', url: '/perfiles', ariaLabel: 'Descubrir perfiles y hacer amigos' },
    { titulo: 'Cuida su salud', subtitulo: 'y bienestar', icono: 'fa-heart-pulse', url: '/login', ariaLabel: 'Ir a la salud y bienestar de tu perfil' },
    { titulo: 'Comparte tus', subtitulo: 'momentos', icono: 'fa-comments', url: '/muros', ariaLabel: 'Compartir momentos en los muros' }
  ];

  constructor(private query: QueryService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.getMisDatos();
  }
  
  getMisDatos(): void {
    this.query.query('misdatos', 'GET', null).subscribe({
      next: (resultado: any) => {
        // El servicio puede devolver el usuario directamente o dentro de registros/datos.
        // El slug es el dato necesario para construir el enlace.
        const candidato = resultado;
        this.misdatos = Array.isArray(candidato) ? (candidato[0] ?? null) : candidato;
        this.cdr.markForCheck();
      },
      error: () => {
        this.misdatos = null;
        this.cdr.markForCheck();
      }
    });
  }

  /** Enlace al perfil cuando hay slug en los datos obtenidos por getMisDatos(). */
  private get urlPerfil(): string | null {
    const slug = String(this.misdatos?.slug ?? '').trim();
    return slug ? this.ruta('perfil/' + encodeURIComponent(slug)) : null;
  }

  /** Primer acceso: registro si es visitante, perfil si está conectado. */
  urlAcceso(acceso: BannerHomeAcceso, indice: number): string {
    if (indice === 0) return this.urlPerfil ?? this.ruta('register');
    if (indice === 2) return this.urlPerfil ?? this.ruta('login');
    return acceso.url;
  }

  tituloAcceso(acceso: BannerHomeAcceso, indice: number): string {
    return indice === 0 && this.urlPerfil ? 'Visita tu perfil' : acceso.titulo;
  }

  subtituloAcceso(acceso: BannerHomeAcceso, indice: number): string {
    return indice === 0 && this.urlPerfil ? 'y el de tu mascota' : acceso.subtitulo;
  }

  iconoAcceso(acceso: BannerHomeAcceso, indice: number): string {
    return indice === 0 && this.urlPerfil ? 'fa-user' : acceso.icono;
  }

  ariaAcceso(acceso: BannerHomeAcceso, indice: number): string {
    return indice === 0 && this.urlPerfil ? 'Visitar mi perfil y el de mi mascota' : acceso.ariaLabel;
  }

  private ruta(path: string): string {
    return this.baseUrl.replace(/\/+$/, '') + '/' + path.replace(/^\/+/, '');
  }

  trackByUrl(_index: number, item: BannerHomeAcceso): string { return item.icono; }
}
